/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import Swal from "sweetalert2";

import linhaCuidadoService from "../../api/atendimentos/linhaCuidadoService";
import operadorasSaudeService from "../../api/planos/operadorasSaudeService";
import TcleLinhaCuidado from "./TcleLinhaCuidado";
import FarmacovigilanciaAtendimento from "./FarmacovigilanciaAtendimento";
import {
    formataDataExibicao,
    formataDataHoraExibicao,
    preferenciasCanalContato,
    preferenciasHorarioContato,
    statusPacienteLinhaCuidado,
    tiposHistoricoLinhaCuidado,
} from "../../common/utils";

class LinhaCuidadoAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvandoParticipacao: false,
            salvandoPaciente: false,
            erro: "",
            paciente: null,
            participacao: null,
            exibeParticipacao: false,
            statusDisponiveis: [],
            operadorasDisponiveis: [],
            formParticipacao: this.getFormParticipacaoInicial(),
            showModalPaciente: false,
            formPaciente: this.getFormPacienteInicial(),
        };
    }

    componentDidMount() {
        this.carregarDados();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregarDados();
        }
    }

    getFormParticipacaoInicial = () => ({
        data_entrada: "",
        data_saida: "",
        data_interrupcao: "",
        data_reinicio: "",
        status_paciente: "",
        motivo_interrupcao: "",
        motivo_reinicio: "",
    });

    getFormPacienteInicial = () => ({
        nome: "",
        data_nascimento: "",
        genero: "",
        cpf: "",
        celular: "",
        telefone: "",
        email: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        cep: "",
        cidade: "",
        uf: "",
        cuidador_nome: "",
        tipo_cuidador: "",
        peso: "",
        altura: "",
        preferencia_canal_contato: "",
        preferencia_horario_contato: "",
        obito: false,
        data_obito: "",
        causa_obito: "",
        operadoras: [],
    });

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregarDados = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, paciente: null, participacao: null });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            // A participação e a lista de operadoras são negadas a perfis que só têm o
            // módulo `cadastro_paciente` (Operadora, Médico, Paciente). Com Promise.all
            // um 403 nessas duas derrubava a aba inteira, escondendo também o cadastro
            // — que esses perfis podem ver. Só o paciente é obrigatório.
            const [resParticipacao, resPaciente, resOperadoras] = await Promise.allSettled([
                linhaCuidadoService.obterParticipacao(atendimentoId),
                linhaCuidadoService.obterPaciente(atendimentoId),
                operadorasSaudeService.listarTodas(),
            ]);

            if (resPaciente.status === "rejected") {
                throw resPaciente.reason;
            }

            const dadosParticipacao =
                resParticipacao.status === "fulfilled" ? resParticipacao.value.data || {} : null;
            const participacao = dadosParticipacao?.participacao || {};
            const operadoras = resOperadoras.status === "fulfilled" ? resOperadoras.value.data : [];

            this.setState({
                loading: false,
                paciente: resPaciente.value.data || null,
                participacao,
                exibeParticipacao: dadosParticipacao !== null,
                statusDisponiveis: Array.isArray(dadosParticipacao?.status_disponiveis)
                    ? dadosParticipacao.status_disponiveis
                    : [],
                operadorasDisponiveis: Array.isArray(operadoras) ? operadoras : [],
                formParticipacao: this.montarFormParticipacao(participacao),
            });
        } catch (error) {
            console.error("Erro ao carregar dados da Linha de Cuidado:", error);
            this.setState({
                loading: false,
                erro: this.getMensagemErro(error, "Não foi possível carregar os dados da Linha de Cuidado."),
            });
        }
    };

    montarFormParticipacao = (participacao) => ({
        data_entrada: participacao?.data_entrada || "",
        data_saida: participacao?.data_saida || "",
        data_interrupcao: participacao?.data_interrupcao || "",
        data_reinicio: participacao?.data_reinicio || "",
        status_paciente: participacao?.status_paciente || "",
        motivo_interrupcao: "",
        motivo_reinicio: "",
    });

    onChangeParticipacao = (event) => {
        const { name, value } = event.target;
        this.setState((estado) => ({
            formParticipacao: { ...estado.formParticipacao, [name]: value },
        }));
    };

    salvarParticipacao = async () => {
        const { atendimentoId } = this.props;
        const { formParticipacao, participacao } = this.state;

        const payload = {
            data_entrada: formParticipacao.data_entrada || null,
            data_saida: formParticipacao.data_saida || null,
            data_interrupcao: formParticipacao.data_interrupcao || null,
            data_reinicio: formParticipacao.data_reinicio || null,
            status_paciente: formParticipacao.status_paciente || null,
        };

        const interrupcaoNova =
            formParticipacao.data_interrupcao && formParticipacao.data_interrupcao !== participacao?.data_interrupcao;
        const reinicioNovo =
            formParticipacao.data_reinicio && formParticipacao.data_reinicio !== participacao?.data_reinicio;

        if (interrupcaoNova) {
            payload.motivo_interrupcao = formParticipacao.motivo_interrupcao || "";
        }

        if (reinicioNovo) {
            payload.motivo_reinicio = formParticipacao.motivo_reinicio || "";
        }

        this.setState({ salvandoParticipacao: true });

        try {
            const resposta = await linhaCuidadoService.atualizarParticipacao(atendimentoId, payload);
            const atualizada = resposta.data || {};

            this.setState({
                salvandoParticipacao: false,
                participacao: atualizada,
                formParticipacao: this.montarFormParticipacao(atualizada),
            });

            Swal.fire("Sucesso", "Participação na Linha de Cuidado atualizada com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao salvar participação na Linha de Cuidado:", error);
            this.setState({ salvandoParticipacao: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível salvar a participação."), "error");
        }
    };

    abrirModalPaciente = () => {
        const { paciente } = this.state;

        this.setState({
            showModalPaciente: true,
            formPaciente: {
                nome: paciente?.nome || "",
                data_nascimento: paciente?.data_nascimento || "",
                genero: paciente?.genero || "",
                cpf: paciente?.cpf || "",
                celular: paciente?.celular || "",
                telefone: paciente?.telefone || "",
                email: paciente?.email || "",
                endereco: paciente?.endereco || "",
                numero: paciente?.numero || "",
                complemento: paciente?.complemento || "",
                bairro: paciente?.bairro || "",
                cep: paciente?.cep || "",
                cidade: paciente?.cidade || "",
                uf: paciente?.uf || "",
                cuidador_nome: paciente?.cuidador_nome || "",
                tipo_cuidador: paciente?.tipo_cuidador || "",
                peso: paciente?.peso ?? "",
                altura: paciente?.altura ?? "",
                preferencia_canal_contato: paciente?.preferencia_canal_contato || "",
                preferencia_horario_contato: paciente?.preferencia_horario_contato || "",
                obito: Boolean(paciente?.obito),
                data_obito: paciente?.data_obito || "",
                causa_obito: paciente?.causa_obito || "",
                operadoras: Array.isArray(paciente?.operadoras)
                    ? paciente.operadoras.map((item) => ({
                          operadora_id: item.operadora_id,
                          id_paciente_operadora: item.id_paciente_operadora || "",
                      }))
                    : [],
            },
        });
    };

    fecharModalPaciente = () => {
        this.setState({ showModalPaciente: false, formPaciente: this.getFormPacienteInicial() });
    };

    onChangePaciente = (event) => {
        const { name, value, type, checked } = event.target;
        this.setState((estado) => ({
            formPaciente: { ...estado.formPaciente, [name]: type === "checkbox" ? checked : value },
        }));
    };

    adicionarOperadora = () => {
        this.setState((estado) => ({
            formPaciente: {
                ...estado.formPaciente,
                operadoras: [...estado.formPaciente.operadoras, { operadora_id: "", id_paciente_operadora: "" }],
            },
        }));
    };

    removerOperadora = (indice) => {
        this.setState((estado) => ({
            formPaciente: {
                ...estado.formPaciente,
                operadoras: estado.formPaciente.operadoras.filter((_, posicao) => posicao !== indice),
            },
        }));
    };

    onChangeOperadora = (indice, campo, valor) => {
        this.setState((estado) => ({
            formPaciente: {
                ...estado.formPaciente,
                operadoras: estado.formPaciente.operadoras.map((item, posicao) =>
                    posicao === indice ? { ...item, [campo]: valor } : item
                ),
            },
        }));
    };

    salvarPaciente = async () => {
        const { atendimentoId } = this.props;
        const { formPaciente } = this.state;

        const operadorasPreenchidas = formPaciente.operadoras.filter((item) => item.operadora_id);
        const idsOperadoras = operadorasPreenchidas.map((item) => String(item.operadora_id));

        if (new Set(idsOperadoras).size !== idsOperadoras.length) {
            Swal.fire("Atenção", "A mesma operadora não pode ser vinculada duas vezes ao paciente.", "warning");
            return;
        }

        if (formPaciente.obito && !formPaciente.data_obito) {
            Swal.fire("Atenção", "Informe a data do óbito.", "warning");
            return;
        }

        if (formPaciente.obito && !formPaciente.causa_obito.trim()) {
            Swal.fire("Atenção", "Informe a causa do óbito.", "warning");
            return;
        }

        const payload = {
            ...formPaciente,
            peso: formPaciente.peso,
            altura: formPaciente.altura,
            data_nascimento: formPaciente.data_nascimento || null,
            data_obito: formPaciente.obito ? formPaciente.data_obito : null,
            causa_obito: formPaciente.obito ? formPaciente.causa_obito : "",
            operadoras: operadorasPreenchidas,
        };

        this.setState({ salvandoPaciente: true });

        try {
            const resposta = await linhaCuidadoService.atualizarPaciente(atendimentoId, payload);

            this.setState({
                salvandoPaciente: false,
                showModalPaciente: false,
                paciente: resposta.data || null,
                formPaciente: this.getFormPacienteInicial(),
            });

            Swal.fire("Sucesso", "Dados do paciente atualizados com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao salvar dados do paciente na Linha de Cuidado:", error);
            this.setState({ salvandoPaciente: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível salvar os dados do paciente."), "error");
        }
    };

    renderCampoLeitura = (label, valor, colunas = 4) => (
        <Col sm={6} lg={colunas} className="mb-3">
            <small className="text-muted d-block">{label}</small>
            <span>{valor === null || valor === undefined || valor === "" ? "-" : valor}</span>
        </Col>
    );

    renderDadosPaciente = () => {
        const { podeEditar } = this.props;
        const { paciente } = this.state;

        if (!paciente) {
            return null;
        }

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <Row className="align-items-center mb-3">
                        <Col sm={8}>
                            <h5 className="mb-0">
                                Dados do Paciente
                                {paciente.obito && (
                                    <Badge bg="dark" className="ms-2">
                                        Óbito
                                    </Badge>
                                )}
                            </h5>
                        </Col>
                        <Col sm={4} className="text-end">
                            {podeEditar && (
                                <Button variant="outline-primary" size="sm" onClick={this.abrirModalPaciente}>
                                    Editar dados cadastrais
                                </Button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        {this.renderCampoLeitura("Nome completo", paciente.nome)}
                        {this.renderCampoLeitura(
                            "Data de nascimento",
                            paciente.data_nascimento ? formataDataExibicao(paciente.data_nascimento) : ""
                        )}
                        {/* campo ausente = mascarado pelo perfil; `!== null` deixava passar undefined */}
                        {this.renderCampoLeitura("Idade", paciente.idade || paciente.idade === 0 ? `${paciente.idade} anos` : "")}
                        {this.renderCampoLeitura("Gênero biológico", paciente.genero_display)}
                        {this.renderCampoLeitura("CPF", paciente.cpf)}
                        {this.renderCampoLeitura("Celular", paciente.celular)}
                        {this.renderCampoLeitura("E-mail", paciente.email)}
                        {this.renderCampoLeitura("Endereço", paciente.endereco_completo, 8)}
                        {this.renderCampoLeitura("Preferência de canal de contato", paciente.preferencia_canal_contato_display)}
                        {this.renderCampoLeitura("Preferência de horário de contato", paciente.preferencia_horario_contato_display)}
                        {this.renderCampoLeitura("Nome do cuidador/responsável", paciente.cuidador_nome)}
                        {this.renderCampoLeitura("Grau de parentesco", paciente.tipo_cuidador)}
                        {this.renderCampoLeitura("Peso", paciente.peso ? `${paciente.peso} kg` : "")}
                        {this.renderCampoLeitura("Altura", paciente.altura ? `${paciente.altura} m` : "")}
                        {paciente.obito && this.renderCampoLeitura(
                            "Data do óbito",
                            paciente.data_obito ? formataDataExibicao(paciente.data_obito) : ""
                        )}
                        {paciente.obito && this.renderCampoLeitura("Causa do óbito", paciente.causa_obito, 8)}
                    </Row>

                    <h6 className="mt-3">Operadoras de Saúde</h6>
                    <Table responsive className="custom-table table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Operadora</th>
                                <th>Registro ANS</th>
                                <th>ID do paciente na operadora</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(paciente.operadoras || []).length === 0 ? (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        Nenhuma operadora vinculada ao paciente.
                                    </td>
                                </tr>
                            ) : (
                                paciente.operadoras.map((operadora) => (
                                    <tr key={operadora.id}>
                                        <td>{operadora.operadora_nome || "-"}</td>
                                        <td>{operadora.registro_ans || "-"}</td>
                                        <td>{operadora.id_paciente_operadora || "-"}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    };

    renderParticipacao = () => {
        const { podeEditar } = this.props;
        const { formParticipacao, participacao, statusDisponiveis, salvandoParticipacao, exibeParticipacao } = this.state;

        // perfil sem o módulo `linha_cuidado` na matriz: a aba mostra só o cadastro
        if (!exibeParticipacao) {
            return null;
        }

        const interrupcaoNova =
            formParticipacao.data_interrupcao && formParticipacao.data_interrupcao !== participacao?.data_interrupcao;
        const reinicioNovo =
            formParticipacao.data_reinicio && formParticipacao.data_reinicio !== participacao?.data_reinicio;

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <h5 className="mb-3">Participação na Linha de Cuidado</h5>

                    <Row>
                        <Col sm={6} lg={3} className="mb-3">
                            <Form.Label>Data de entrada</Form.Label>
                            <Form.Control
                                type="date"
                                name="data_entrada"
                                value={formParticipacao.data_entrada}
                                onChange={this.onChangeParticipacao}
                                disabled={!podeEditar}
                            />
                        </Col>
                        <Col sm={6} lg={3} className="mb-3">
                            <Form.Label>Data de saída</Form.Label>
                            <Form.Control
                                type="date"
                                name="data_saida"
                                value={formParticipacao.data_saida}
                                onChange={this.onChangeParticipacao}
                                disabled={!podeEditar}
                            />
                        </Col>
                        <Col sm={6} lg={3} className="mb-3">
                            <Form.Label>Data de interrupção</Form.Label>
                            <Form.Control
                                type="date"
                                name="data_interrupcao"
                                value={formParticipacao.data_interrupcao}
                                onChange={this.onChangeParticipacao}
                                disabled={!podeEditar}
                            />
                        </Col>
                        <Col sm={6} lg={3} className="mb-3">
                            <Form.Label>Data de reinício</Form.Label>
                            <Form.Control
                                type="date"
                                name="data_reinicio"
                                value={formParticipacao.data_reinicio}
                                onChange={this.onChangeParticipacao}
                                disabled={!podeEditar}
                            />
                        </Col>
                        <Col sm={12} lg={6} className="mb-3">
                            <Form.Label>Status do paciente</Form.Label>
                            <Form.Select
                                name="status_paciente"
                                value={formParticipacao.status_paciente}
                                onChange={this.onChangeParticipacao}
                                disabled={!podeEditar}
                            >
                                <option value="">Selecione</option>
                                {statusDisponiveis.map((grupo) => (
                                    <optgroup key={grupo.grupo} label={grupo.grupo_label}>
                                        {grupo.opcoes.map((opcao) => (
                                            <option key={opcao.value} value={opcao.value}>
                                                {opcao.label}
                                            </option>
                                        ))}
                                    </optgroup>
                                ))}
                            </Form.Select>
                        </Col>
                        {interrupcaoNova && (
                            <Col sm={12} lg={6} className="mb-3">
                                <Form.Label>Motivo da interrupção</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="motivo_interrupcao"
                                    value={formParticipacao.motivo_interrupcao}
                                    onChange={this.onChangeParticipacao}
                                    disabled={!podeEditar}
                                />
                            </Col>
                        )}
                        {reinicioNovo && (
                            <Col sm={12} lg={6} className="mb-3">
                                <Form.Label>Motivo do reinício</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="motivo_reinicio"
                                    value={formParticipacao.motivo_reinicio}
                                    onChange={this.onChangeParticipacao}
                                    disabled={!podeEditar}
                                />
                            </Col>
                        )}
                    </Row>

                    {podeEditar && (
                        <div className="text-end">
                            <Button variant="primary" onClick={this.salvarParticipacao} disabled={salvandoParticipacao}>
                                {salvandoParticipacao ? "Salvando..." : "Salvar participação"}
                            </Button>
                        </div>
                    )}
                </Card.Body>
            </Card>
        );
    };

    renderHistorico = () => {
        const { participacao } = this.state;
        const historico = participacao?.historico || [];

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <h5 className="mb-3">Histórico de Interrupções e Reinícios</h5>
                    <Table responsive className="custom-table table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Data</th>
                                <th>Motivo</th>
                                <th>Registrado por</th>
                                <th>Data do registro</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historico.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="text-center">
                                        Nenhuma interrupção ou reinício registrado.
                                    </td>
                                </tr>
                            ) : (
                                historico.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <Badge bg={item.tipo === "interrupcao" ? "warning" : "success"}>
                                                {tiposHistoricoLinhaCuidado[item.tipo] || item.tipo_display || "-"}
                                            </Badge>
                                        </td>
                                        <td>{item.data ? formataDataExibicao(item.data) : "-"}</td>
                                        <td>{item.motivo || "-"}</td>
                                        <td>{item.usuario_nome || "-"}</td>
                                        <td>{item.data_registro ? formataDataHoraExibicao(item.data_registro) : "-"}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    };

    renderModalPaciente = () => {
        const { showModalPaciente, formPaciente, operadorasDisponiveis, salvandoPaciente } = this.state;

        return (
            <Modal show={showModalPaciente} onHide={this.fecharModalPaciente} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Editar dados cadastrais</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h6 className="mb-3">Dados pessoais</h6>
                    <Row>
                        <Col sm={12} lg={6} className="mb-3">
                            <Form.Label>Nome completo</Form.Label>
                            <Form.Control name="nome" value={formPaciente.nome} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={6} lg={3} className="mb-3">
                            <Form.Label>Data de nascimento</Form.Label>
                            <Form.Control
                                type="date"
                                name="data_nascimento"
                                value={formPaciente.data_nascimento}
                                onChange={this.onChangePaciente}
                            />
                        </Col>
                        <Col sm={6} lg={3} className="mb-3">
                            <Form.Label>CPF</Form.Label>
                            <Form.Control name="cpf" value={formPaciente.cpf} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={6} lg={4} className="mb-3">
                            <Form.Label>Celular</Form.Label>
                            <Form.Control name="celular" value={formPaciente.celular} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={6} lg={4} className="mb-3">
                            <Form.Label>Telefone</Form.Label>
                            <Form.Control name="telefone" value={formPaciente.telefone} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={12} lg={4} className="mb-3">
                            <Form.Label>E-mail</Form.Label>
                            <Form.Control type="email" name="email" value={formPaciente.email} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={6} lg={4} className="mb-3">
                            <Form.Label>Peso (kg)</Form.Label>
                            <Form.Control
                                name="peso"
                                value={formPaciente.peso}
                                onChange={this.onChangePaciente}
                            />
                        </Col>
                        <Col sm={6} lg={4} className="mb-3">
                            <Form.Label>Altura (m)</Form.Label>
                            <Form.Control
                                name="altura"
                                value={formPaciente.altura}
                                onChange={this.onChangePaciente}
                            />
                        </Col>
                        <Col sm={6} lg={4} className="mb-3">
                            <Form.Label>Nome do cuidador/responsável</Form.Label>
                            <Form.Control
                                name="cuidador_nome"
                                value={formPaciente.cuidador_nome}
                                onChange={this.onChangePaciente}
                            />
                        </Col>
                    </Row>

                    <h6 className="mb-3 mt-2">Endereço</h6>
                    <Row>
                        <Col sm={12} lg={6} className="mb-3">
                            <Form.Label>Logradouro</Form.Label>
                            <Form.Control name="endereco" value={formPaciente.endereco} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={4} lg={2} className="mb-3">
                            <Form.Label>Número</Form.Label>
                            <Form.Control name="numero" value={formPaciente.numero} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={8} lg={4} className="mb-3">
                            <Form.Label>Complemento</Form.Label>
                            <Form.Control
                                name="complemento"
                                value={formPaciente.complemento}
                                onChange={this.onChangePaciente}
                            />
                        </Col>
                        <Col sm={6} lg={4} className="mb-3">
                            <Form.Label>Bairro</Form.Label>
                            <Form.Control name="bairro" value={formPaciente.bairro} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={6} lg={3} className="mb-3">
                            <Form.Label>CEP</Form.Label>
                            <Form.Control name="cep" value={formPaciente.cep} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={8} lg={3} className="mb-3">
                            <Form.Label>Cidade</Form.Label>
                            <Form.Control name="cidade" value={formPaciente.cidade} onChange={this.onChangePaciente} />
                        </Col>
                        <Col sm={4} lg={2} className="mb-3">
                            <Form.Label>UF</Form.Label>
                            <Form.Control maxLength={2} name="uf" value={formPaciente.uf} onChange={this.onChangePaciente} />
                        </Col>
                    </Row>

                    <h6 className="mb-3 mt-2">Preferências de contato</h6>
                    <Row>
                        <Col sm={6} className="mb-3">
                            <Form.Label>Preferência de canal</Form.Label>
                            <Form.Select
                                name="preferencia_canal_contato"
                                value={formPaciente.preferencia_canal_contato}
                                onChange={this.onChangePaciente}
                            >
                                <option value="">Selecione</option>
                                {Object.entries(preferenciasCanalContato).map(([valor, label]) => (
                                    <option key={valor} value={valor}>
                                        {label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col sm={6} className="mb-3">
                            <Form.Label>Preferência de horário</Form.Label>
                            <Form.Select
                                name="preferencia_horario_contato"
                                value={formPaciente.preferencia_horario_contato}
                                onChange={this.onChangePaciente}
                            >
                                <option value="">Selecione</option>
                                {Object.entries(preferenciasHorarioContato).map(([valor, label]) => (
                                    <option key={valor} value={valor}>
                                        {label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>

                    <Row className="align-items-center mb-2 mt-2">
                        <Col sm={8}>
                            <h6 className="mb-0">Operadoras de Saúde</h6>
                        </Col>
                        <Col sm={4} className="text-end">
                            <Button variant="outline-primary" size="sm" onClick={this.adicionarOperadora}>
                                Adicionar operadora
                            </Button>
                        </Col>
                    </Row>
                    {formPaciente.operadoras.length === 0 ? (
                        <p className="text-muted">Nenhuma operadora vinculada.</p>
                    ) : (
                        formPaciente.operadoras.map((item, indice) => (
                            <Row key={`operadora-${indice}`} className="align-items-end mb-2">
                                <Col sm={6}>
                                    <Form.Label>Operadora</Form.Label>
                                    <Form.Select
                                        value={item.operadora_id}
                                        onChange={(event) =>
                                            this.onChangeOperadora(indice, "operadora_id", event.target.value)
                                        }
                                    >
                                        <option value="">Selecione</option>
                                        {operadorasDisponiveis.map((operadora) => (
                                            <option key={operadora.id} value={operadora.id}>
                                                {operadora.nome}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col sm={4}>
                                    <Form.Label>ID do paciente na operadora</Form.Label>
                                    <Form.Control
                                        value={item.id_paciente_operadora}
                                        onChange={(event) =>
                                            this.onChangeOperadora(indice, "id_paciente_operadora", event.target.value)
                                        }
                                    />
                                </Col>
                                <Col sm={2}>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => this.removerOperadora(indice)}
                                    >
                                        Remover
                                    </Button>
                                </Col>
                            </Row>
                        ))
                    )}

                    <h6 className="mb-3 mt-4">Óbito</h6>
                    <Row>
                        <Col sm={12} className="mb-3">
                            <Form.Check
                                type="checkbox"
                                id="linha-cuidado-obito"
                                label="Paciente veio a óbito"
                                name="obito"
                                checked={formPaciente.obito}
                                onChange={this.onChangePaciente}
                            />
                        </Col>
                        {formPaciente.obito && (
                            <>
                                <Col sm={6} lg={4} className="mb-3">
                                    <Form.Label>Data do óbito *</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="data_obito"
                                        max={new Date().toISOString().slice(0, 10)}
                                        value={formPaciente.data_obito}
                                        onChange={this.onChangePaciente}
                                    />
                                </Col>
                                <Col sm={12} lg={8} className="mb-3">
                                    <Form.Label>Causa do óbito *</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        name="causa_obito"
                                        value={formPaciente.causa_obito}
                                        onChange={this.onChangePaciente}
                                    />
                                </Col>
                            </>
                        )}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModalPaciente} disabled={salvandoPaciente}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvarPaciente} disabled={salvandoPaciente}>
                        {salvandoPaciente ? "Salvando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        const { loading, erro, participacao } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-4">
                    <Spinner animation="border" />
                </div>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        return (
            <>
                {participacao?.status_paciente && (
                    <Alert variant="info" className="mt-4 mb-0">
                        Status atual: <strong>{statusPacienteLinhaCuidado[participacao.status_paciente]}</strong>
                    </Alert>
                )}
                {this.renderDadosPaciente()}
                {this.renderParticipacao()}
                {this.renderHistorico()}
                {/* perfis sem esses módulos na matriz (ex.: Operadora) veriam só um aviso de 403 */}
                {this.props.exibeTcle && (
                    <TcleLinhaCuidado atendimentoId={this.props.atendimentoId} podeEditar={this.props.podeEditar} />
                )}
                {this.props.exibeFarmacovigilancia && (
                    <FarmacovigilanciaAtendimento atendimentoId={this.props.atendimentoId} />
                )}
                {this.renderModalPaciente()}
            </>
        );
    }
}

export default LinhaCuidadoAtendimento;
